import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const WhiteButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
  return (
    <IfmsButton ref={ref} {...other} baseClass="ifms-white-button">
      {children}
    </IfmsButton>
  );
});

WhiteButton.defaultProps = {
};

WhiteButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large']),
};

export default React.memo(WhiteButton);

